import { Link } from 'react-router-dom'
import { PiCopy, PiTrash } from 'react-icons/pi'
import { Dashboard } from '../dashboards'
import { CardActions } from './CardActions'
import { LIBRARY_CARD_CLASS } from './ReportCard'
import { REPORT_ICONS } from './reportIcons'

/** Library card for a dashboard — mirrors ReportCard styling. */
export function DashboardCard({
  dashboard,
  onDelete,
  onDuplicate,
}: {
  dashboard: Dashboard
  /** Present only for user-built (saved) dashboards — shipped ones aren't deletable. */
  onDelete?: () => void
  /** Clone into "Your Dashboards"; offered on shipped and saved dashboards alike. */
  onDuplicate?: () => void
}) {
  const Icon = REPORT_ICONS[dashboard.icon ?? 'dashboard']
  return (
    <div className="relative group">
      <Link
        to={`/reporting/dashboards/${dashboard.id}`}
        className={LIBRARY_CARD_CLASS}
      >
        <div className="size-9 rounded-lg bg-brand-active/10 flex items-center justify-center text-brand-active">
          <Icon size={18} />
        </div>
        <div className="font-semibold text-fg">{dashboard.name}</div>
        <div className="text-sm text-fg-secondary">{dashboard.description}</div>
      </Link>
      <CardActions
        actions={[
          onDuplicate && {
            label: `Duplicate ${dashboard.name}`,
            icon: PiCopy,
            onClick: onDuplicate,
          },
          onDelete && {
            label: `Delete ${dashboard.name}`,
            icon: PiTrash,
            onClick: onDelete,
          },
        ]}
      />
    </div>
  )
}
